/**
 * dataLayer: view_item_list + search.
 * Runs once on load; pushes when corresponding data attribute is present.
 * Uses GA4 standard event names per spec.
 * Note: Predictive search lightbox is not instrumented (backlog). Search event only fires on full search results page load.
 */
(function () {
  'use strict';

  /** @type {Window & { dataLayer?: object[] }} */
  var win = window;
  var dl = win.dataLayer || [];
  win.dataLayer = dl;

  function pushCollectionView() {
    var el = document.querySelector('[data-datalayer-collection-title]');
    if (!el) return;
    var title = el.getAttribute('data-datalayer-collection-title');
    if (!title || title.trim() === '') return;
    var handle = (el.getAttribute('data-datalayer-collection-handle') || '').trim();
    var url = (el.getAttribute('data-datalayer-collection-url') || '').trim();
    var ecommerce = {
      item_list_name: title.trim(),
      ...(handle ? { item_list_id: handle } : {}),
      ...(url ? { url: url } : {})
    };
    dl.push({ ecommerce: null });
    dl.push({ event: 'view_item_list', ecommerce: ecommerce });
  }

  function pushSearch() {
    var el = document.querySelector('[data-datalayer-search-term]');
    if (!el) return false;
    if (el.closest('.search-results-page')) return false;
    var term = el.getAttribute('data-datalayer-search-term');
    if (term == null || String(term).trim() === '') return false;
    var resultsCountStr = el.getAttribute('data-datalayer-search-results-count');
    var n = (resultsCountStr != null && resultsCountStr !== '') ? parseInt(resultsCountStr, 10) : NaN;
    var count = (!isNaN(n) && n >= 0) ? n : 0;
    var searchUrl = (el.getAttribute('data-datalayer-search-url') || '').trim();
    var payload = Object.assign(
      { event: 'search', search_term: String(term).trim(), results_count: count },
      searchUrl ? { url: searchUrl } : {}
    );
    dl.push({ ecommerce: null });
    dl.push(payload);
    return true;
  }

  function run() {
    pushCollectionView();
    var searchPushed = pushSearch();
    // Retry only when not on Algolia search page (Algolia handles its own search event)
    if (!searchPushed && !document.querySelector('.search-results-page')) {
      setTimeout(pushSearch, 600);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
